<template>
  <div class="col-md-6">
    <company-details :anchor="null" :company-overview="companyOverview" />
  </div>
</template>

<script>
import CompanyDetails from '@/components/companies/panels/CompanyDetails';

export default {
  components: {
    CompanyDetails,
  },
  name: 'LeftColumn',
  props: {
    companyOverview: {
      required: true,
      type: Object,
    },
  },
};
</script>

<style scoped></style>
